import { Pipe, PipeTransform } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';


@Pipe({
  name: 'timeAgo',
  pure: false
})
export class TimeAgoPipe implements PipeTransform {
  constructor(private translate: TranslateService) {}

  transform(date: Date | string): string {
    if (!date) return '';

    const now = new Date();
    const past = new Date(date);
    const seconds = Math.floor((now.getTime() - past.getTime()) / 1000);

    const intervals = [
      { key: 'YEAR_AGO', seconds: 31536000 },
      { key: 'MONTH_AGO', seconds: 2592000 },
      { key: 'WEEK_AGO', seconds: 604800 },
      { key: 'DAY_AGO', seconds: 86400 },
      { key: 'HR_AGO', seconds: 3600 },
      { key: 'MIN_AGO', seconds: 60 },
      { key: 'SEC_AGO', seconds: 1 },
    ];

    for (const interval of intervals) {
      const count = Math.floor(seconds / interval.seconds);
      if (count >= 1) {
        const unit = this.translate.instant(`SETTINGS.${interval.key}`) || interval.key;
        return `${count} ${unit}`;
      }
    }

    return ' ' + this.translate.instant('SETTINGS.SEC_AGO');
  }
}
